module.exports = __webpack_public_path__ + "img/whats-w.661588c5.png";